/*
 *		Copyright (c) 2011-2016 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

/**
 * Small directive aimed to integrate Angular based data tables with jQuery generated events for reload. It binds to events
 * declared in acc-reload-table-on attribute and calls the reload of the table visible in the current scope.
 *
 */
angular.module('access.DataTable')
    .directive('accReloadTableOn', [function() {
        return {
            scope: true,
            link: function ($scope, $element, $attrs) {
                $element.on($attrs['accReloadTableOn'], function (event) {
                    $scope.table.reload();
                    event.stopPropagation();
                })
            }

        }
    }]);